import * as binding from "./binding.js" ;
import context from '../util/context.js';
import download from "downloadjs" ;
import { waiter, uuidv4, loadScript } from "../util/utils.js";
import { error, confirm, info } from "../util/dialogs.js";

let viewInc = 0;
export class ViewController {
    constructor({page, id}){
        this.viewId = new Date().getTime()+"-"+viewInc++ ;
        this.options = {
            page: page, 
            id: id
        };
        this.data = {} ;
        this.actions = { 
            binding: binding,
            refresh: ()=>{ return this.bind(true) ; },
            formBackToList: (listRoute)=> { this.formBackToList(listRoute); },
            formCreate: ()=> { window.location.href = window.location.href.replace(/\/read\/.*/, "/create"); },
            formModify: ()=> { window.location.href = window.location.href.replace(/\/read\//, "/modify/"); },
            formCancel: (listUrl)=> { 
                if(this.actions.closePopup){
                    return this.actions.closePopup() ;
                }
                if(/\/modify\//.test(window.location.href)){
                window.location.href = window.location.href.replace(/\/modify\//, "/read/") ;
            }else{
                if(listUrl && typeof(listUrl) === "string"){
                    window.location.href = listUrl ;
                }else{
                    window.location.href = window.location.href.replace(/\/form\/create.*/, "/list/") ;
                }
            } },
            formDelete: (buttonElement, customConfirmMessage) =>{ return this.formDelete(buttonElement, customConfirmMessage); },
            formGetDataToSave: (form, fieldId="_id") =>{ return this.formGetDataToSave(form, fieldId); },
            formSaveData: (form, fieldId="_id") =>{ return this.formSaveData(form, fieldId); },
            formCheckAndSave: (form, fieldId="_id") =>{ return this.formCheckAndSave(form, fieldId); },
            formSave: (buttonElement) =>{ return this.formSave(buttonElement); },
            formCheck: (form) =>{ 
                return waiter(this.formCheck(form)).then((validationErrors)=>{
                    if(validationErrors.length>0){
                        error(validationErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("")) ;
                        return false;
                    }else{
                        return true ;
                    }
                });
            },
            printAndSaveEdition: (buttonElement,fieldName, templateCode, data, templateFilename, templateLang)=>{
                return this.printAndSaveEdition(buttonElement, fieldName, templateCode, data, templateFilename, templateLang) ;
            },
            saveEdition: (buttonElement, fieldName, templateCode, data, templateFilename, templateLang)=>{
                return this.saveEdition(buttonElement, fieldName, templateCode, data, templateFilename, templateLang) ;
            },
            printEdition: (templateCode, data, templateFilename, templateLang)=>{
                return this.printEdition(templateCode, data, templateFilename, templateLang) ;
            },
            generateEdition: (templateCode, data, templateFilename, templateLang)=>{
                return this.generateEdition(templateCode, data, templateFilename, templateLang) ;
            },
            formPrint: (buttonElement, templateCode, templateFilename, templateLang, templateSearch)=>{
                return this.formPrint(buttonElement, templateCode, templateFilename, templateLang, templateSearch) ;
            },
            formEmail: (buttonElement, templateCode, templateLang)=>{
                return this.formEmail(buttonElement, templateCode, templateLang) ;
            },
            sendEmail: (data, templateCode, templateLang)=>{
                return this.sendEmail(data, templateCode, templateLang) ;
            },
            createExcel: (data)=>{
                return this.createExcel(data) ;
            },
            createCsv: (data)=>{
                return this.createCsv(data) ;
            },
            navigationOpenNext: ()=>{
                if(this.body._globals.context.navigationUrls && this.body._globals.context.navigationIndex < this.body._globals.context.navigationUrls.length - 1){
                    window.location.href = this.body._globals.context.navigationUrls[++this.body._globals.context.navigationIndex] ;
                }
            },
            navigationOpenPrevious: ()=>{
                if(this.body._globals.context.navigationUrls && this.body._globals.context.navigationIndex > 0){
                    window.location.href = this.body._globals.context.navigationUrls[--this.body._globals.context.navigationIndex] ;
                }
            },
            navigationOpenFirst: ()=>{
                if(this.body._globals.context.navigationUrls && this.body._globals.context.navigationIndex > 0){
                    this.body._globals.context.navigationIndex = 0 ;
                    window.location.href = this.body._globals.context.navigationUrls[this.body._globals.context.navigationIndex] ;
                }
            },
            navigationOpenLast: ()=>{
                if(this.body._globals.context.navigationUrls && this.body._globals.context.navigationIndex < this.body._globals.context.navigationUrls.length - 1){
                    this.body._globals.context.navigationIndex = this.body._globals.context.navigationUrls.length - 1 ;
                    window.location.href = this.body._globals.context.navigationUrls[this.body._globals.context.navigationIndex] ;
                }
            },
            create: (table, obj)=>{
                return waiter(window.restApi.create(table, obj).then((result)=> this.bind().then(()=> result) )) ;
            },
            delete: (table, objOrId)=>{
                let id = objOrId ;
                if(typeof(id) === "object"){
                    id = id._id ;
                }
                return waiter(window.restApi.delete(table, id).then((result)=> this.bind().then(()=> result) )) ;
            },
            update: (table, objOrId, obj)=>{
                let id = objOrId ;
                let objToUpdate = obj;
                if(typeof(id) === "object"){
                    id = id._id ;
                    objToUpdate = id;
                }
                return waiter(window.restApi.update(table, id, objToUpdate).then((result)=> this.bind().then(()=> result) )) ;
            },
            changeLang: (lang)=>{
                const context = this.body._globals.context ;
                if(context.currentUser && context.currentUser.login !== "anonymous"){
                    waiter(window.getRestApi("$bamz").update("users", context.currentUser.login, {lang: lang})).then(()=>{
                        context.currentLang = lang ;
                    }) ;
                }else{
                    context.currentLang = lang ;
                }
            }
        } ;
        this.renderWaiters = [] ;
    }

    execRoute(route){
        this.route = route;
        return this.prepareView().then(()=>{
            route.render = (div)=>{
                // this.renderView(div, route) ;
                return this.renderView(div, route) ;
            } ;
        }) ; 
    }

    fetchHtml(){
        return fetch(this.options.page+".html")
        .then((response) => {
            return response.text();
        }) ;
    }

    createTemplate(html){
        this.template = document.createElement("template") ;
        

        this.headerTags = [];
       
        let stylesheets = document.head.querySelectorAll('link[rel="stylesheet"]') ;
        for(let i = 0; i<stylesheets.length; i++){
            this.headerTags.push(stylesheets[i].outerHTML.replace(/&amp;/g, "&")) ;
        }

        //this code is copied tp sources.html, remember to report any bug fix

        //replace all string content to ___ to avoid take in string markup to be real markup
        // ex : <script>el.innerHTML = '<div>foo</div>'</script>
        // to : <script>el.innerHTML = '______________'</script>
        let htmlNoString = "" ;
        let inComment = false;
        let commentOnLine = false;
        let inString = false;
        let inRegexp = false;
        let inExprLevel = 0;
        let inExprBrace = 0;
        let inExprBraceMemo = [] ;
        let isEscaped = false;
        let stringChar = "";
        for(let i=0; i<html.length; i++){
            const c = html[i] ;

            if(inString){
                //we are inside a string
                if(stringChar === "`" && !isEscaped && c === "$" && html[i+1] === "{"){
                    // we are inside a ` string and starting a ${...} expression

                    //increment level (because we can have expression within expression)
                    inExprLevel++ ;

                    //keep inside brace counter in memo because we can be inside a parent expression that we will continue after
                    inExprBraceMemo.push(inExprBrace) ;
                    //init inner brace count
                    inExprBrace = 0 ;

                    //not in string anymore
                    inString = false;

                    //add char in result string
                    htmlNoString += c ;
                    htmlNoString += html[i+1] ;
                    i++ ;
                }else if(isEscaped){
                    //previous char is \ remove next char
                    isEscaped = false;
                    htmlNoString += "_" ;
                }else if(c === "\\"){
                    //next char will be escaped
                    isEscaped = true;
                    htmlNoString += "_" ;
                }else if(c===stringChar){
                    //match closing string
                    htmlNoString += c ;
                    inString = false;
                }else{
                    //all other case : replace char by _
                    htmlNoString += "_" ;
                }
            }else if(inComment){
                //inside a comment
                if(c === "\n" && commentOnLine){
                    //this is end of line and we are in // comment so the comment is finished
                    htmlNoString += c ;
                    inComment = false;
                }else if(c === "*" && i<html.length-1 && html[i+1]==="/"){
                    //found */ end of comment pattern
                    htmlNoString += c ;
                    htmlNoString += html[i+1] ;
                    i++;
                    inComment = false;
                }else{
                    //all other case : replace char by _
                    htmlNoString += "_" ;
                }
            }else if(inRegexp){
                //inside a /regexp/
                if(c === "\n"){
                    //end of line, regexp is finished
                    htmlNoString += c ;
                    inRegexp = false;
                }else if(c === "/" && html[i-1]!=="\\"){
                    //not escaped /, regexp is finished
                    htmlNoString += c ;
                    inRegexp = false;
                }else{
                    //all other case : replace char by _
                    htmlNoString += "_" ;
                }
            }else if(inExprLevel && c === "}"){
                //we are in an ${expression} inside a `string` and char is a closing }

                //in all case, add the char
                htmlNoString += c ;
                if(inExprBrace){
                    //there is not closed { in the expression, we just close the brace
                    inExprBrace-- ;
                }else{
                    //this is the end of the expression

                    //get brace in the memo because it may be an expression within an expression
                    inExprBrace = inExprBraceMemo.pop()||0 ;

                    //close current expression
                    inExprLevel--;

                    //go back in `string mode`
                    inString = true;
                    stringChar = "`" ;
                }
            }else{
                //other cases

                if(inExprLevel && c === "{"){
                    //we are inside an ${expression} and we open a inside brace {
                    inExprBrace++ ;
                }
                
                //keep character
                htmlNoString += c ;
                if(c === "/" && i<html.length-1 && (html[i+1]==="/" || html[i+1]==="*")){
                    //start of a comment
                    htmlNoString += html[i+1] ;
                    if(html[i+1]==="/"){ commentOnLine = true; }
                    i++;
                    inComment = true ;
                }else if(!inRegexp && c === '"' || c === "'" || c === "`"){
                    //start of a string
                    inString = true ;
                    stringChar = c;
                }else if(c === '/' && html[i-1]!=="<" && html[i+1]!==">" && html[i+1]!==" "){
                    // start of regexp
                    inRegexp = true ;
                //}else if(c === '/'){
                    // console.log("NOT IN REGEXP ? "+html.substring(i-5, i+2), inTag) ;
                }
            }
        }

        let firstNonHeaderTag = htmlNoString.match(/<(?!(?:script|style|\/))[\w\d\s="_-]*>/i);
        
        this.scriptTags = [] ;
        if(firstNonHeaderTag){
            let htmlHeader = html.substring(0, firstNonHeaderTag.index) ;
            let htmlHeaderNoString = htmlNoString.substring(0, firstNonHeaderTag.index) ;

            let tagScript = htmlHeaderNoString.match(/<script/i);
            while(tagScript){
                const endTag = htmlHeaderNoString.match(/<\/script>/i);
                if(endTag){
                    const indexEnd = htmlHeaderNoString.indexOf(">", endTag.index) ;
                    const scriptTag = htmlHeader.substring(tagScript.index, indexEnd+1) ;
                    this.headerTags.push(scriptTag) ;
                    htmlHeader = htmlHeader.substring(indexEnd+1);
                    htmlHeaderNoString = htmlHeaderNoString.substring(indexEnd+1);
                    tagScript = htmlHeaderNoString.match(/<script/i);
                }else{
                    throw "Tag <script> missing end </script>" ;
                }
            }

            htmlHeader = html.substring(0, firstNonHeaderTag.index) ;
            htmlHeaderNoString = htmlNoString.substring(0, firstNonHeaderTag.index) ;

            let tagStyle = htmlHeaderNoString.match(/<style/i);
            while(tagStyle){
                const endTag = htmlHeaderNoString.match(/<\/style/i);
                if(endTag){
                    const indexEnd = htmlHeaderNoString.indexOf(">", endTag.index) ;
                    const styleTag = htmlHeader.substring(tagStyle.index, indexEnd+1) ;
                    this.headerTags.push(styleTag) ;
                    htmlHeader = htmlHeader.substring(indexEnd+1);
                    htmlHeaderNoString = htmlHeaderNoString.substring(indexEnd+1);
                    tagStyle = htmlHeaderNoString.match(/<style/i);
                }else{
                    throw "Tag <style> missing end </style>" ;
                }
            }

            htmlHeader = html.substring(0, firstNonHeaderTag.index) ;
            htmlHeaderNoString = htmlNoString.substring(0, firstNonHeaderTag.index) ;
            
            let tagLink = htmlHeaderNoString.match(/<link/i);
            while(tagLink){
                let closeTag = htmlHeaderNoString.match(/<\/link/i);
                let closeInnerTag = htmlHeaderNoString.match(/\/>/i);
                let endTagIndex = 0;
                if(closeTag && !closeInnerTag){
                    endTagIndex = closeTag.index;
                }else if(!closeTag && closeInnerTag){
                    endTagIndex = closeInnerTag.index;
                }else{
                    endTagIndex = Math.min(closeTag.index, closeInnerTag.index);
                }
                if(endTagIndex){
                    const indexEnd = htmlHeaderNoString.indexOf(">", endTagIndex) ;
                    const linkTag = htmlHeader.substring(tagLink.index, indexEnd+1) ;
                    this.headerTags.push(linkTag) ;
                    htmlHeader = htmlHeader.substring(indexEnd+1);
                    htmlHeaderNoString = htmlHeaderNoString.substring(indexEnd+1);
                    tagLink = htmlHeaderNoString.match(/<link/i);
                }else{
                    throw "Tag <link> missing end </link>" ;
                }
            }

            html = html.substring(firstNonHeaderTag.index) ;
        }
        

        html = `<div z-hide-if="${false}" style="width: 100%; height: 100%; ${this.embedded?'':'overflow: auto;'} display: none" class="view-tag view-${this.options.id}">${html}</div>` ;
        this.template.innerHTML = html ;
        document.body.appendChild(this.template) ;
        

        const self = this ;
        customElements.define('view-'+this.viewId,
            class extends HTMLElement {
                constructor() {
                    super();
                    self.starterRendered = true ;

                    let templateContent = self.template.content;

                    self.body = this.attachShadow({mode: 'open'}) ;


                    self.body.getData = ()=>{ 
                        const data = self.data ;
                        return { ...data, 
                            _globals: {
                                params : self.route?self.route.params:{}, 
                                pathname: self.route?self.route.pathname:"",
                                context: context, actions: self.actions
                            } 
                        } ; 
                    } ;

                    const clone = document.importNode(templateContent, true);
                    const bodyEl = document.createElement("body") ;
                    if(self.embedded){
                        bodyEl.className = "z-embedded" ;
                    }
                    bodyEl.appendChild(clone) ;

                    const thisId = "view_shadow_root_"+uuidv4() ;
                    window[thisId] = this.shadowRoot ;
                    window[thisId+"_actions"] = self.actions ;
                    this.shadowRoot._viewController = self ;
                    this.shadowRoot.createElement = function(){
                        return document.createElement.apply(document, arguments) ;
                    } ;
                    this.shadowRoot.loadScript = (url)=>{
                        // let head = this.shadowRoot;
                        // if(this.shadowRoot.head){
                        //     head = this.shadowRoot.head ;
                        // }
                        return loadScript(url) ;
                    } ;
                    this.shadowRoot.loadCss = (url)=>{
                        let head = this.shadowRoot;
                        if(this.shadowRoot.head){
                            head = this.shadowRoot.head ;
                        }
                        return new Promise((resolve)=>{
                            var link = document.createElement("link");
                            link.rel = "stylesheet";
                            link.type = "text/css";
                            link.href = url;
                            
                            
                            head.appendChild(link);
                            resolve() ;
                        }) ;
                    } ;

                    let scriptIndex = 0;
                    for(let headerTag of self.headerTags){
                        let indexSpace = headerTag.indexOf(" ");
                        let indexClose = headerTag.indexOf(">");
                        let indexEndTagName = 0;
                        if(indexSpace !== -1 && indexSpace<indexClose){
                            indexEndTagName = indexSpace ;
                        }else{
                            indexEndTagName = indexClose ;
                        }
                        let tagName = headerTag.substring(1, indexEndTagName).toUpperCase() ;
                        let elHeader = document.createElement(tagName) ;
                        if(indexEndTagName === indexSpace){
                            let attributes = headerTag.substring(indexEndTagName, indexClose).trim().split(" ") ;
                            for(let attr of attributes){
                                if(attr.trim()){
                                    let indexEqual = attr.indexOf("=") ;
                                    if(indexEqual !== -1){
                                        const attrName = attr.substring(0, indexEqual).trim() ;
                                        const attrValue = attr.substring(indexEqual+1).trim().replace(/^["']/, "").replace(/["']$/, "") ;
                                        elHeader.setAttribute(attrName, attrValue) ;
                                    }else if(attr.trim() !== "/"){
                                        elHeader.setAttribute(attr.trim(), "") ;
                                    }
                                }
                            }
                        }
                        let tagEndIndex = headerTag.lastIndexOf("</") ;
                        let tagBody = headerTag.substring(indexClose+1, tagEndIndex) ;

                        if(tagBody.trim()){
                            if(tagName === "SCRIPT"){

                                let indexLoadData = tagBody.search(/loadData\s*\(/) ;
                                if(indexLoadData !== -1){
                                    let indexBody = tagBody.indexOf("{") ;
                                    if(indexBody !== -1){
                                        indexBody++ ;
                                        let countBrace = 1;
                                        let indexEndBody = null;
                                        for(let i = indexBody; i<tagBody.length; i++){
                                            let c = tagBody[i] ;
                                            if(c === "{"){
                                                countBrace++;
                                            }else if(c === "}"){
                                                countBrace--;
                                            }
                                            if(countBrace === 0){
                                                indexEndBody = i-1;
                                                break;
                                            }
                                        }
                                        if(indexEndBody){
                                            let indexEndLoadData = tagBody.length;
                                            for(let i = indexEndBody+2; i<tagBody.length; i++){
                                                let c = tagBody[i] ;
                                                if(c !== " " && c !== "\r" && c !== "\n" && c !== ")" && c !== ";"){
                                                    indexEndLoadData = i-1;
                                                    break;
                                                }
                                            }
                                            let dataToLoadFuncBody = tagBody.substring(indexBody, indexEndBody).trim() ;
                                            self.dataToLoadFunc = new Function("data", dataToLoadFuncBody) ;
                                            tagBody = tagBody.substring(0,indexLoadData).trim()+tagBody.substring(indexEndLoadData) ;
                                        }
                                    }
                                }

                                scriptIndex++ ;
                                tagBody = `
                                (function(document, actions){
                                    function onReady(callback){
                                        /*document.addEventListener("bindEnd", ()=>{
                                            document.querySelector("div").scrollTop = 0 ;
                                        }, {once: true}) ;*/
                                        if(!document){ return ; }
                                        document.addEventListener("bindEnd", ()=>{
                                            let onReadyCallback = callback() ;
                                            if(typeof(onReadyCallback) === "object" && onReadyCallback.constructor === Promise){
                                                onReadyCallback.then(()=>{
                                                    document.dispatchEvent(new CustomEvent("onReadyDone")) ;
                                                })
                                            }else{
                                                document.dispatchEvent(new CustomEvent("onReadyDone")) ;
                                            }
                                        }, {once: true}) ;
                                        document.addEventListener("refresh", callback) ;
                                    }
                                    function onLoad(callback){
                                        document.addEventListener("bindStart", callback, {once: true}) ;
                                        document.addEventListener("refreshStart", ()=>{
                                            document.addEventListener("bindStart", callback, {once: true}) ;
                                        }) ;
                                    }
                                    function onDisplayed(callback){
                                        onReady(()=>{
                                            let imgs = document.querySelectorAll("img") ;
                                            let promises = [] ;
                                            for(let img of imgs){
                                                promises.push(new Promise((resolve, reject)=>{
                                                    if(img.complete){
                                                        resolve() ;
                                                    }else{
                                                        img.addEventListener("load",function(){
                                                            resolve() ;
                                                        });
                                                        img.addEventListener("error",function(){
                                                            resolve() ;
                                                        });
                                                    }
                                                })) ;
                                            }
                                            Promise.all(promises).then(()=>{
                                                return new Promise((resolve)=>{
                                                    let resolved = false;
                                                    function check(){
                                                        if(window.getComputedStyle(document.querySelector(".view-tag")).display === "block"){
                                                            resolved = true ;
                                                            resolve() ;
                                                        }else{
                                                            setTimeout(check, 50) ;
                                                        }
                                                    }
                                                    check() ;
                                                    setTimeout(()=>{
                                                        if(!resolved){
                                                            resolve() ;
                                                        }
                                                    }, 300) ;

                                                })
                                            }).then(()=>{
                                                callback() ;
                                            }) ;
                                        })
                                    }

                                    
                                    ${tagBody}
                                })(window["${thisId}"], window["${thisId}_actions"]) ;
                                
                                //# sourceURL=${(self.options.page||"inline").replace(/.html$/, "")}-${scriptIndex}.js `;
                            }
                            elHeader.innerHTML = tagBody ;
                        }
                        self.body.appendChild(elHeader) ;
                    }

                    self.body.appendChild(bodyEl);

                    waiter(self.bind().then(()=>{
                        self.body.closeMenus = function(){
                            let menus = self.body.querySelectorAll(".dropdown-menu");
                            for(let menu of menus){
                                menu.classList.remove("show");
                                if(menu.parentElement){
                                    menu.parentElement.classList.remove("show");
                                }
                            }
                        };

                        self.body.addEventListener("click", ev=> {
                            let target = ev._originalTarget || ev.target;
                            if(!ev._originalTarget){
                                ev._originalTarget = ev.target ;
                            }
                            if(!target.closest(".dropdown")){
                                self.body.closeMenus();
                            }
                        });


                        window.document.addEventListener("click", (ev)=>{
                            let target = ev._originalTarget || ev.target;
                            if(target.shadowRoot && target.shadowRoot !== self.body){
                                self.body.closeMenus() ;
                            }else if(!target.shadowRoot && target.getRootNode() !== self.body){
                                self.body.closeMenus() ;
                            }
                        });


                        if(self.container){
                            self.body.addEventListener("onReadyDone", ()=>{
                                self.container.dispatchEvent(new CustomEvent("viewReadyDone", {detail: {page: self.options.page, id: self.options.id, pageDocument: self.body}, bubbles: true})) ;    
                            }, {once: true}) ;
                            self.container.dispatchEvent(new CustomEvent("viewRendered", {detail: {page: self.options.page, id: self.options.id, pageDocument: self.body}, bubbles: true})) ;
                        }
                        let imgs = document.querySelectorAll("img") ;
                        let promises = [] ;
                        for(let img of imgs){
                            promises.push(new Promise((resolve, reject)=>{
                                if(img.complete){
                                    resolve() ;
                                }else{
                                    img.addEventListener("load",function(){
                                        resolve() ;
                                    });
                                    img.addEventListener("error",function(){
                                        resolve() ;
                                    });
                                }
                            })) ;
                        }
                        return Promise.all(promises) ;
                    }), self.container).finally(()=>{
                        if(self.container){
                            self.container.dispatchEvent(new CustomEvent("viewDisplayed", {detail: {page: self.options.page, id: self.options.id, pageDocument: self.body}, bubbles: true})) ;
                        }
                        while(self.renderWaiters.length>0){
                            self.renderWaiters.pop()() ;
                        }
                    }) ;

                }
        }) ;
    }

    prepareView(){
        if(this.template){
            return new Promise((resolve)=>{ resolve() ; }) ;
        }
        return this.fetchHtml().then((html) => {
            this.createTemplate(html) ;
        }) ;
    }

    refreshView(newData){
        this.data = newData ;
        this.body._globals = {params : this.body._globals.params, context: context, actions: this.actions} ;
        this.body.dispatchEvent(new CustomEvent("refreshStart"));
        binding.bind(this.body, this.data, null).then(()=>{
            this.body.dispatchEvent(new CustomEvent("refresh"));
        }) ;
    }

    bind(forceRefresh = false){
        const newGlobals = {
            params : this.route?(this.route.params||{}):{}, 
            pathname: this.route?this.route.pathname:"",
            context: context, actions: this.actions} ;
        this.body._globals = newGlobals ;
        window.tr(this.body) ;
        let data = this.data ;
        if(this.body && this.body.__zzBindData){
            data = this.body.__zzBindData ;
            if(!data._globals){
                data._globals = newGlobals ;
            }else{
                Object.keys(newGlobals).forEach((k)=>{
                    data._globals[k] = newGlobals[k] ;
                }) ;
            }
        }else{
            if(data._globals){
                data._globals = newGlobals ;
            }
        }

        if(!data._globals){
            data._globals = newGlobals ;
        }

        return new Promise((resolve, reject)=>{
            let dataToLoad = null;
            if(this.dataToLoadFunc){
                dataToLoad = this.dataToLoadFunc(data) ;
            }
            this.dataToLoad = dataToLoad ;
            if(!dataToLoad){
                return resolve() ;
            }
            Promise.all(Object.keys(dataToLoad).map(k=>{
                return this.fetchLoadData(data, dataToLoad, k) ;
            })).then(resolve).catch(reject) ;
        }).then(()=>{
            const promiseBind = binding.bind(this.body, data, null, null, forceRefresh) ;
            window.tr(this.body) ;
            return promiseBind.then(()=>{
                if(this.dataToLoadFunc){
                    this.body.addEventListener("bindEnd", ()=>{
                        let data = this.getData() ;
                        let dataToLoad = this.dataToLoadFunc(data) ;
                        if(dataToLoad){
                            let changedFetch = Object.keys(dataToLoad).filter(
                                k=>JSON.stringify(dataToLoad[k]) !== JSON.stringify(this.dataToLoad[k])) ;
                            if(changedFetch.length>0){
                                this.dataToLoad = dataToLoad;
                                changedFetch.map(k=>{
                                    console.log("Reload "+k) ;
                                    return this.fetchLoadData(this.getData(), dataToLoad, k) ;
                                }) ;
                            }
                        }
                    });
                }
                if(!this.embedded){
                    this.body.__zzBindData._globals.params.addListener("*", (ev)=>{
                        let urlParts = context.currentScreen.route.split("/");
                        urlParts = urlParts.map(part=>{
                            if(part[0] === ":"){
                                let paramName = part.substring(1) ;
                                let isOptional = false;
                                if(paramName[paramName.length-1] === "?"){
                                    isOptional = true ;
                                    paramName = paramName.substring(0, paramName.length-1) ;
                                }
                                if(this.body.__zzBindData._globals.params[paramName]){
                                    return this.body.__zzBindData._globals.params[paramName] ;
                                }else if(isOptional){
                                    return "";
                                }else{
                                    "_" ;
                                }
                            }else{
                                return part;
                            }
                        }) ;
                        let newUrl = "/"+urlParts.filter(p=>p!=="").join("/") ;
                        console.log("change params", ev) ;
                        document.location.hash = "#"+newUrl ;
                    }) ;
                }
                if(forceRefresh){
                    this.body.dispatchEvent(new CustomEvent("refresh"));
                }
            }) ;
        }) ;
    }

    getData(){
        return this.body.__zzBindData ;
    }

    areEqual(variable1, variable2) {
        // Check if the types of the two variables are the same
        if (typeof variable1 !== typeof variable2) {
          return false;
        }
      
        // If the variables are of primitive type, compare them directly
        if (typeof variable1 !== "object" || variable1 === null) {
          return variable1 === variable2;
        }
      
        // If the variables are objects or arrays, compare their properties or elements
        if (Array.isArray(variable1)) {
          if (variable1.length !== variable2.length) {
            return false;
          }
          for (let i = 0; i < variable1.length; i++) {
            if (!this.areEqual(variable1[i], variable2[i])) {
              return false;
            }
          }
        } else {
          const keys1 = Object.keys(variable1);
          for (const key of keys1) {
            if (!this.areEqual(variable1[key], variable2[key])) {
              return false;
            }
          }
        }
      
        return true;
    }
      

    fetchLoadData(data, dataToLoad, k){
        if(!this.fetchLoadDataIds){
            this.fetchLoadDataIds = {} ;
        }
        if(!this.fetchLoadDataIds[k]){
            this.fetchLoadDataIds[k] = 0 ;
        }
        this.fetchLoadDataIds[k] ++ ; 
        let thisFetchId = this.fetchLoadDataIds[k] ;
        let promiseFetch = null;
        if(typeof(dataToLoad[k]) === "function"){
            promiseFetch = dataToLoad[k]();
            if(!promiseFetch || promiseFetch.constructor !== Promise){
                promiseFetch = Promise.resolve(promiseFetch) ;
            }
        }else if(dataToLoad[k].search){
            promiseFetch =  window.restApi.search(dataToLoad[k].table, dataToLoad[k].search) ;
        }else if(dataToLoad[k].read){
            promiseFetch =  window.restApi.read(dataToLoad[k].table, dataToLoad[k].read) ;
        }       
        if(promiseFetch){
            return promiseFetch.then(r=>{
                if(thisFetchId !== this.fetchLoadDataIds[k]){
                    //ID has changed, meaning that a new fetch started in the meantime, ingore this result
                    return; 
                }
                if(!this.areEqual(r, data[k])){
                    data[k] = r ;
                }
            }) ;
        }else{
            return Promise.resolve() ;
        }
    }

    createViewEl(preload){
        if(this.viewEl){
            if(!preload){
                return waiter(this.bind()).then(()=>{
                    this.body.dispatchEvent(new CustomEvent("viewDisplayed"));
                }) ;
            }
            return;
        }
        let divView = document.createElement("DIV") ;
        divView.style.display = "none" ;
        window.document.body.appendChild(divView) ;
        //we must do innerHTML = "" instead of createElement to have it in DOM on init 
        divView.innerHTML = "<view-"+this.viewId+" id=\""+this.options.id+"\" class=\"view-controller-container\"></view-"+this.viewId+">" ;
        this.viewEl = divView.children[0] ;
        window.document.body.appendChild(this.viewEl) ;
        window.document.body.removeChild(divView) ;

    }

    renderView(div, route={}){
        this.route = route ;
        this.data = {} ;
        if(this.container === div && this.container.getAttribute("z-view") === this.options.page){
            //already active, refresh
            // waiter(this.bind()).then(()=>{
            //     this.body.dispatchEvent(new CustomEvent("refresh"));
            // }) ;
            // return;
            return waiter(this.bind()).then(()=>{
                this.body.dispatchEvent(new CustomEvent("refresh"));
            }) ;
        }
        this.container = div ;
        this.container.setAttribute("z-view", this.options.page) ;

       // return waiter(
       return     new Promise((resolve)=>{
                let resolved = false;
                let doResolve = function(){
                    if(!resolved){
                        resolved = true;
                        resolve() ;
                    }
                } ;
                setTimeout(()=>{
                    if(!this.starterRendered){
                        //not inserted in DOM after 1ms, stop to wait
                        doResolve() ;
                    }
                }, 1) ;
                setTimeout(()=>{
                    //not resolved after 1sec, resolve anyway, it should not be that long
                    doResolve() ;
                }, 1000) ;
                const renderWaiter = ()=>{
                    doResolve() ;
                };
                this.renderWaiters.push(renderWaiter) ;

                if(window.cacheView){
                    this.createViewEl() ;
                    let children  = Array.prototype.slice.apply(this.container.children) ;
                    
                    this.container.appendChild(this.viewEl);
                    this.viewEl.style.display = "" ;
                    for(let c of children){
                        //hide and move existing view
                        c.style.position = "absolute";
                        c.style.top = 0;
                        c.style.left = 0;
                        c.style.bottom = 0;
                        c.style.right = 0;
                        c.style.zIndex = 9;
                        c.style.transition = "opacity 1s ease-in-out";
                        c.style.opacity = 0;
                        setTimeout(()=>{
                            c.style.display = "none" ;
                            c.style.position = "";
                            c.style.top = 0;
                            c.style.left = 0;
                            c.style.bottom = 0;
                            c.style.right = 0;
                            c.style.transition = "";
                            c.style.opacity = 1;
                            c.style.zIndex = 0;
                            window.document.body.appendChild(c) ;
                        }, 1000);
                    }
                }else{
                    this.container.innerHTML = "<view-"+this.viewId+" id=\""+this.options.id+"\" class=\"view-controller-container\"></view-"+this.viewId+">" ;
                }
            })
        //)
        .then(()=>{
            this.container.dispatchEvent(new CustomEvent("viewLoaded", {detail: {page: this.options.page, id: this.options.id}, bubbles: true})) ;
            //console.log("VIEW LOAD ENDED "+this.options.page, this.container) ;
        }) ;
    }


    formBackToList(listRoute){
        if(!listRoute || typeof(listRoute) !== "string"){
            listRoute = window.location.hash.replace(/\/form\/read.*/, '/list/').replace(/\/form\/create/, '/list/').substring(1) ;
        }
        //search last grid search
        let strStates = localStorage.getItem("grid_states") ;
        let states = {} ;
        if(strStates){
            try{
                states = JSON.parse(strStates) ;
            }catch(err){ console.error("Can't parse grid states", err) ;}
        }
        let statesIds = Object.keys(states).filter(state=>{
            return states[state].grid_route && states[state].grid_route.includes(listRoute);
        }).sort((s1, s2)=>{
            return states[s1].date>states[s2].date?1:-1 ;
        })  ;
        if(statesIds.length>0){
            listRoute += statesIds.pop() ;
        }
        
        window.location.hash = "#"+listRoute ;
    }

    formDelete(buttonElement, customConfirmMessage){
        const form = buttonElement.closest("form");

        if(!form){ throw "Button delete should be inside a form" ; }

        let fieldId = "_id" ;
        if(buttonElement.hasAttribute("z-field-id")){
            fieldId = buttonElement.getAttribute("z-field-id") ;
        }

        let confirmMessage = customConfirmMessage||window.tr("form.areYouSureDelete") ;

        confirm(confirmMessage).then((yes)=>{
            if(!yes){ return ;}
            waiter(
                binding.deleteRecord(form, fieldId).then((deletedRecord)=>{
                    return new Promise((resolve, reject)=>{
                        let afterDelete = buttonElement.getAttribute("z-after-delete") ;
                        if(afterDelete){
                            const afterDeleteObj = binding.runInContext(buttonElement, {deletedRecord}, afterDelete) ;
                            if(typeof(afterDeleteObj) === "object" && afterDeleteObj.constructor === Promise){
                                //the result is a promise, wait for it to resolve !
                                return afterDeleteObj.then(resolve).catch(reject) ;
                            }else{
                                return resolve() ;
                            }
                        }


                        let nextUrl = buttonElement.getAttribute("z-next-url") ;
                        if(nextUrl){
                            resolve(nextUrl.replace("{{id}}", deletedRecord[fieldId])) ;
                        }else{
                            resolve(window.location.href.replace(/\/form\/read.*/, "/list/")) ;
                        }
                    }) ;
                })
            ).then((nextUrl)=>{
                if(nextUrl){
                    window.location.href = nextUrl ;
                }
            }) ;
        }) ;
    }

    formCheckAndSave(form, fieldId = "_id"){
        return new Promise((resolve, reject)=>{
            return this.formCheck(form).then((validationErrors)=>{
                if(validationErrors.length>0){
                    return reject(validationErrors) ;
                }
                binding.save(form, fieldId).then((savedRecord)=>{
                    resolve(savedRecord) ;
                }).catch(reject);
            }).catch(reject);
        }) ;
    }
    formSaveData(form, fieldId = "_id"){
        return binding.save(form, fieldId);
    }

    formGetDataToSave(form, fieldId = "_id"){
        const dataPatch = binding.getSavePatch(form, fieldId) ;
        return dataPatch.dataPatch ;
    }

    formSave(buttonElement){
        const form = buttonElement.closest("form");
        const zForm = buttonElement.closest("z-form");
        
        let fieldId = "_id" ;
        if(buttonElement.hasAttribute("z-field-id")){
            fieldId = buttonElement.getAttribute("z-field-id") ;
        }

        form.dispatchEvent(new Event("beforeSave")) ;

        return waiter(this.formCheck(form)).then((validationErrors)=>{
            const feedbackEl = form.querySelector("z-error-feedback") ;
            if(feedbackEl){
                feedbackEl.value = "" ;
            }
            if(validationErrors.length>0){
                if(feedbackEl){
                    feedbackEl.value = validationErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("") ;
                }else{
                    error(validationErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("")) ;
                }
            }else{
                return waiter(
                    binding.save(form, fieldId).then((savedRecord)=>{

                        if(this.actions.closePopup && !buttonElement.hasAttribute("z-dont-close-popup")){
                            //open in popup, close it
                            return this.actions.closePopup(savedRecord) ;
                        }

                        return new Promise((resolve, reject)=>{
                            let afterSaveAttr = buttonElement.getAttribute("z-after-save") ;
                            if(afterSaveAttr){
                                const afterSaveObj = binding.runInContext(buttonElement, {savedRecord}, afterSaveAttr) ;
                                if(typeof(afterSaveObj) === "object" && afterSaveObj.constructor === Promise){
                                    //the result is a promise, wait for it to resolve !
                                    return afterSaveObj.then(resolve).catch(reject) ;
                                }else{
                                    return resolve() ;
                                }
                            }

                            let nextUrl = buttonElement.getAttribute("z-next-url") ;
                            if(nextUrl){
                                resolve(nextUrl.replace("{{id}}", savedRecord[fieldId])) ;
                            }else{
                                if(zForm && zForm.hasAttribute("z-inner-form")){
                                    return info(window.tr("form.saveSuccess")).then(()=> this.bind()).then(resolve).catch(reject) ;
                                }else{
                                    resolve(window.location.href
                                        .replace(/\/modify\//, "/read/")
                                        .replace(/\/create/, "/read/"+savedRecord[fieldId])
                                    ) ;
                                }
                            }
                        }) ;
                    }).catch((err)=>{
                        console.log(err) ;
                        let errMsg = err;
                        if(err.name){
                            errMsg = err.name;
                        }
                        const trKey = "error."+errMsg ;
                        const trMsg = window.tr(trKey) ;
                        if(trMsg !== trKey){
                            errMsg = trMsg;
                        }
                        if(this.errorHandler){
                            errMsg = this.errorHandler(err) ;
                        }
                        if(feedbackEl){
                            feedbackEl.value = errMsg;
                        }else{
                            error(errMsg) ;
                        }
                    })
                ).then((nextUrl)=>{
                    if(nextUrl && nextUrl !== "none"){
                        window.location.href = nextUrl ;
                    }
                }) ;
            }
        }) ;

    }

    formCheck(form){
        let noForm = false;
        if(!form){
            form = this.body ;
        }
        if(form.tagName === "Z-FORM"){
            form = form.querySelector("form") ;
        }

        if(form.tagName !== "FORM"){
            noForm = true;
        }

        let validations = form.validations || [];
        form.classList.add("was-validated") ;

        let errors = [] ;
        let promises = [] ;
        validations.forEach((validation)=>{
            let data = form.__zzBindData ;
            if(!data){
                data = {} ;
                binding.update(form, data) ;
            }
            let validationResult = validation({ form: form, data: data, tr: window.tr }) ;
            if(validationResult && typeof(validationResult) && validationResult.constructor === Promise){
                promises = validationResult ;
            }else{
                promises.push(new Promise((resolve/*, reject*/)=>{
                    return resolve(validationResult) ;
                })) ;
            }
        });
        return Promise.all(promises).then((results)=>{
            results.forEach((result)=>{
                let detectedErrors = result;
                if(!detectedErrors){ detectedErrors = [] ;}
                if(detectedErrors && !Array.isArray(detectedErrors)){
                    detectedErrors = [detectedErrors];
                }
                detectedErrors.forEach(function(e, i){
                    if(typeof(e) === "string"){
                        detectedErrors[i]= {msg : e} ;
                    }
                }) ;
                errors = errors.concat(detectedErrors||[]) ;
            }) ;

            let invalidFields = form.querySelectorAll(":invalid") ;
            for(let i=0; i<invalidFields.length; i++){
                const invalidEl = invalidFields[i] ;
                if(invalidEl.manualInvalid){
                    delete invalidEl.manualInvalid ;
                    invalidEl.setCustomValidity("");
                }
            }
            
            let globalErrors = [] ;
            for(let i=0; i<errors.length; i++){
                const error = errors[i] ;
                if(error.field){
                    var elInput = form.querySelector('[z-bind="'+error.field+'"]') ;
                    if(elInput){
                        elInput.setCustomValidity(error.msg);
                        elInput.manualInvalid = true ;
                    }else{
                        globalErrors.push(error) ;
                    }
                }else{
                    globalErrors.push(error) ;
                }
            }

            if(!noForm){
                //real form, use form checkValidity
                form.checkValidity() ;
            }else{
                //no form, check all form elements
                const formElms = Array.prototype.slice.apply(form.querySelectorAll('input'))
                .concat(
                    Array.prototype.slice.apply(form.querySelectorAll('select'))
                ).concat(
                    Array.prototype.slice.apply(form.querySelectorAll('textarea'))
                ) ;
                for(let el of formElms){
                    el.checkValidity() ;
                }
            }


            invalidFields = form.querySelectorAll(":invalid") ;
            for(let i=0; i<invalidFields.length; i++){
                const invalidEl = invalidFields[i] ;
                const message = invalidEl.validationMessage ;
                if(message){
                    let parentEl = invalidEl.closest(".form-group")||invalidEl ;
                    let feedbackEl = parentEl.querySelector(".invalid-feedback") ;
                    if(feedbackEl){
                        feedbackEl.innerHTML = message ;
                    }
                    let labelEl = parentEl.querySelector("label") ;
                    let label = "" ;
                    if(labelEl){
                        label = labelEl.innerHTML;
                    }
                    globalErrors.push({
                        el: parentEl,
                        field: invalidEl.getAttribute("z-bind"),
                        label: label,
                        msg: (label?label+" : ":"")+message
                    }) ;
                }
            }

            if(globalErrors.length === 0){
                form.classList.remove("was-validated") ;
            }

            return Promise.resolve(globalErrors) ;
        }) ;
    }

    printEdition(templateCode, data, templateFilename, templateLang){
        return waiter(this.generateEdition(templateCode, data, templateFilename, templateLang).then(({buffer, responseFilename}) => {
            let filename = responseFilename||window.tr("form.printDefaultName") ;
            if(window.native && window.native.openFile){
                window.native.openFile(filename, buffer, "application/pdf") ;
            }else{
                //browser
                var file = new Blob([buffer], {type: 'application/pdf'});
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                const url = window.URL.createObjectURL(file);
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a) ;
            }
        })) ;
    }
    
    printAndSaveEdition(buttonElement, fieldName, templateCode, data, templateFilename, templateLang){
        const form = buttonElement.closest("form");

        if(!form){ throw "Button print should be inside a form" ; }

        let fieldId = "_id" ;
        if(buttonElement.hasAttribute("z-field-id")){
            fieldId = buttonElement.getAttribute("z-field-id") ;
        }

        const dataPatch = binding.getSavePatch(form, fieldId) ;
        
        
        return waiter(this.generateEdition(templateCode, data, templateFilename, templateLang).then(({buffer, responseFilename, mimetype}) => {
            
            dataPatch.dataPatch = {} ;
            dataPatch.dataPatch[fieldName] = new File([buffer], responseFilename||window.tr("form.printDefaultName"), {
                type: mimetype,
            });
            return binding.save(dataPatch, fieldId).then(()=>{
                let filename = responseFilename||window.tr("form.printDefaultName") ;
                if(window.native && window.native.openFile){
                    window.native.openFile(filename, buffer, mimetype) ;
                }else{
                    //browser
                    var file = new Blob([buffer], {type: mimetype});
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    const url = window.URL.createObjectURL(file);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a) ;
                }
            }) ;
        })) ;
    }
    
    saveEdition(buttonElement, fieldName, templateCode, data, templateFilename, templateLang){
        const form = buttonElement.closest("form");

        if(!form){ throw "Button print should be inside a form" ; }

        let fieldId = "_id" ;
        if(buttonElement.hasAttribute("z-field-id")){
            fieldId = buttonElement.getAttribute("z-field-id") ;
        }

        const dataPatch = binding.getSavePatch(form, fieldId) ;
        
        
        return waiter(this.generateEdition(templateCode, data, templateFilename, templateLang).then(({buffer, responseFilename, mimetype}) => {
            dataPatch.dataPatch = {} ;
            dataPatch.dataPatch[fieldName] = new File([buffer], responseFilename||window.tr("form.printDefaultName"), {
                type: mimetype,
            });
            return binding.save(dataPatch, fieldId) ;
        })) ;
    }

    generateEdition(templateCode, data, templateFilename, templateLang){
        const form = document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("enctype", "multipart/form-data");
        const formData  = new FormData(form);

        formData.append('data', JSON.stringify(data)) ;

        const query = [
            {
              code: "code",
              value: templateCode
            },
            {
              code: "lang",
              value: templateLang||"fr"
            },
            {
              code: "filename",
              value: templateFilename
            },
        ]
        .filter(q=>{ return q.value ; })
        .map(q=>{
            let value = q.value;
            if(typeof(value) === "object"){
                value = JSON.stringify(value) ;
            }
            return q.code+"="+encodeURIComponent(value) ;
        }).join("&") ;

        let responseFilename;

        return fetch("/printEdition?"+query, {
            method: "POST", 
            credentials: 'include', 
            body: formData
        }).then((response)=>{
            if(response.status < 200 || response.status > 299){
                return response.text().then((text)=>{
                    let msg = text;
                    try{
                        msg = JSON.parse(text) ;
                    }catch(e){
                        //ignore parse error, it is not a JSON object
                    }
                    if(!msg){
                        msg = "error" ; 
                    }
                    throw msg ;
                }) ;
            }
            let disposition = response.headers.get("content-disposition") ;
            let mimetype = response.headers.get("content-type") ;
            if(disposition){
                const indexStart = disposition.indexOf('="') ;
                if(indexStart !== -1){
                    const indexEnd = disposition.indexOf('"', indexStart+2) ;
                    if(indexEnd !== -1){
                        responseFilename = disposition.substring(indexStart+2, indexEnd) ;
                    }
                }
            }
            return response.arrayBuffer().then(buffer=>{
                return {responseFilename, buffer: buffer, mimetype}; 
            }) ;
        }) ;
    }


    formPrint(buttonElement, templateCode, templateFilename, templateLang, templateSearch){
        if(!templateCode){
            //model not specified, see if we are inside a form
            const zForm = buttonElement.closest("z-form") ;
            if(zForm && zForm.hasAttribute("z-model")){
                templateCode = zForm.getAttribute("z-model") ;
            }else{
                const zList = buttonElement.closest("z-list") ;
                if(zList && zList.hasAttribute("z-model")){
                    templateCode = zList.getAttribute("z-model") ;
                }else{
                    throw "missing model on button print" ;
                }   
            }
        }
        if(!templateSearch){
            //model not specified, see if we are inside a form
            const zForm = buttonElement.closest("z-form") ;
            if(zForm){
                const {data} = binding.getSavePatch(buttonElement) ;
                templateSearch = {_id: data._id} ;
            }else{
                const zList = buttonElement.closest("z-list") ;
                if(zList){
                    //FIXME: get the selection in grid
                    templateSearch = {} ;
                }else{
                    throw "missing search on button print" ;
                }   
            }
        }
        const query = [
            {
              code: "model",
              value: templateCode
            },
            {
              code: "search",
              value: templateSearch
            },
            {
              code: "code",
              value: templateCode
            },
            {
              code: "lang",
              value: templateLang
            },
            {
              code: "filename",
              value: templateFilename
            },
        ]
        .filter(q=>{ return q.value ; })
        .map(q=>{
            let value = q.value;
            if(typeof(value) === "object"){
                value = JSON.stringify(value) ;
            }
            return q.code+"="+encodeURIComponent(value) ;
        }).join("&") ;
        let responseFilename ;
        waiter(
            fetch("/printLink?"+query).then((response)=>{
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                let disposition = response.headers.get("content-disposition") ;
                if(disposition){
                    const indexStart = disposition.indexOf('="') ;
                    if(indexStart !== -1){
                        const indexEnd = disposition.indexOf('"', indexStart+2) ;
                        if(indexEnd !== -1){
                            responseFilename = disposition.substring(indexStart+2, indexEnd) ;
                        }
                    }
                }
                return response.arrayBuffer(); 
            }).then(buffer => {
                let filename = responseFilename||window.tr("form.printDefaultName") ;
                if(window.native && window.native.openFile){
                    window.native.openFile(filename, buffer, "application/pdf") ;
                }else{
                    //browser
                    var file = new Blob([buffer], {type: "application/pdf"});
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    const url = window.URL.createObjectURL(file);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a) ;
                }
            })
        ) ;
    }

    formEmail(buttonElement, templateCode, templateLang){
        const {data} = binding.getSavePatch(buttonElement) ;
        this.sendEmail(data, templateCode, templateLang) ;
    }

    sendEmail(data, templateCode, templateLang){
        waiter(
            window.restApi.list("_mail_templates", [{column: "code", value: templateCode}]).then((templates)=>{
                if(templates.length === 0){
                    throw window.tr("templates.thisTemplateDoesNotExist", {code: templateCode}) ;
                }

                data.server___host = window.location.host ;
                data.__app_code = window.APP.name ;

                return window.restApi.create("_mail_queue", {
                    status: "tosend", 
                    template_code: templateCode,
                    template_params: JSON.stringify(data),
                    lang: templateLang||null,
                    create_date: new Date()
                });
            })
        ).then(()=>{
            info(window.tr("templates.emailSent")) ;
        }) ;
    }

    createExcel(data){
        let formData = new FormData();

        const blob = new Blob([JSON.stringify(data)], {type : 'application/json'});
        formData.append("data", blob, "data.json");

        return waiter(fetch("/api/utils/createXls", {
            method: "POST",
            credentials: 'include',
            body: formData
        }).then(function(response) {
            if(response.status === 401){
                throw("NOT_LOGGED") ;
            }
            return response.blob();
        }).then(function(blob) {
            download(blob, data.filename||"export.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        })) ;
    }

    createCsv(data){
        let {lines, filename, separator, eof, eol,  encoding, quote} = data ;
        if(!separator){
            separator = ";";
        }
        if(!quote){
            quote = '"';
        }
        if(eof && !eol){
            eol = eof ;
        }
        if(!eol){
            eol = "\r\n";
        }
        if(!encoding){
            encoding = "ISO-8859-1";
        }

        let csv = lines.map(
            line=>{
                return line.map(cell=>{
                    cell = ""+cell ;
                    if(cell.includes(separator) || cell.includes("\n") || cell.includes(quote)){
                        return quote+cell.replace(new RegExp(quote, "g"), quote+quote)+quote ;
                    }
                    return cell ;
                }).join(separator||";") ;
            }
        ).join(eol||"\r\n") ;

        var textFileAsBlob = new Blob([csv], {
            type: 'text/csv;charset='+encoding, 
            encoding: encoding
        });

        download(textFileAsBlob, filename||"export.csv", "text/csv");
    }
}